export default {
  model: {
    'role': '角色',
    'activeStorage/attachment': 'Attachment',
    'application': '应用管理',
    'adminUsersRole': '管理员',
    'adminUser': '管理员',
    'banner': '轮播图',
    'profile': 'Profile',
    'student': '学员信息',
    'member': '会员信息',
    'user': '用户',
    'inviteRelationship': '推荐关系',
    'activeStorage/blob': '资源',
    'actsAsTaggableOn/tag': '标签',
    'page': '页面',
    'presetPage': '页面',
    'staticPage': '页面',
    'customPage': '自定义页面',
    'hotWord': '搜索热词',
    'commentableCommentDatum': 'Commentable comment datum',
    'post': 'Post',
    'article': '文章',
    'customPostList': '自定义文章列表',
    'customPostListsPost': 'Custom post lists post',
    'comment': '评论',
    'normalComment': '评论',
    'specialColumn': '专栏',
    'specialColumnArticleRelation': 'Special column article relation',
    'seekTruthWeekly': '求真周刊',
    'seekTruthVideo': '求真视频',
    'bookClub': '读书会',
    'bookList': '书单',
    'podcast': '播客',
    'experienceComment': '读书会心得',
    'reason': '退款理由',
    'applyRecord': '报名记录',
    'priceType': 'Price type',
    'priceTypeTemplate': '青训营价格模板',
    'youthCamp': '青训营',
    'invoiceApplyRecord': '发票申请记录',
    'youthCampExperienceComment': '青训营心得',
    'operationRecord': '操作日志',
    'setting': '平台设置',
  },
  'role': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    kind: '类型',
    kinds: {
      super: 'Super',
      application: '应用管理',
      custom: 'Custom',
    },
    customPermissions: '自定义权限',
  },
  'activeStorage/attachment': {
    id: 'ID',
    createdAt: '创建时间',
    signedId: 'Signed',
    contentType: '内容类型',
    filename: 'Filename',
    byteSize: 'Byte size',
    url: 'Url',
  },
  'application': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    desc: '描述',
    shareDesc: '分享描述',
    shareTitle: '分享标题',
    trackingCodeDesc: '推荐码使用提示',
    displayingVideo: '小程序是否显示视频模块',
    wechatApplicationId: 'Wechat application',
    auditComment: '评论自动审核',
    applicationAdminUsersRoleId: 'Application admin users role',
    shareImage: '分享图片',
    logo: 'Logo',
    creator: 'Creator',
    posterImage: '海报图片',
  },
  'adminUsersRole': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    roleId: '角色',
    adminUserId: 'Admin user',
    applicationId: '应用ID',
    role: '角色',
    application: '应用管理',
    adminUser: '管理员',
    adminUserAttributes: 'Admin user attributes',
  },
  'adminUser': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    email: '邮箱',
    name: '姓名',
    adminUsersRolesAttributes: 'Admin users roles attributes',
  },
  'banner': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    target: '目标',
    position: '优先级',
    pagePosition: '页面位置',
    pagePositions: {
      book_club: '读书会页面',
      youth_camp: '青训营页面',
    },
    kind: '类型',
    kinds: {
      web_link: '网站链接',
      image: '纯图片',
      mp_link: '小程序链接',
    },
    alt: '图片描述',
    image: '图片',
  },
  'profile': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    email: '邮箱',
    phone: '手机号码',
    gender: '性别',
    genders: {
      unknown: 'Unknown',
      male: 'Male',
      female: 'Female',
    },
  },
  'student': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    bookClubCourseNumbers: '参加读书会的期数（用逗号隔开）',
    city: '常驻城市',
    courseStickiness: '上课粘性',
    courseTimes: '上课次数',
    coursesCount: '上课期次',
    height: '身高（cm）',
    name: '名称',
    npsList: 'NPS名单',
    npsSource: 'NPS来源',
    npsValue: 'NPS值',
    occupation: '职业',
    phone: '手机号码',
    weight: '体重（kg）',
    youthCampCourseNumbers: '参加青训营的期数（用逗号隔开）',
    gender: '性别',
    genders: {
      unknown: '未知',
      male: '男',
      female: '女',
    },
    userId: '用户',
    bridge: '桥梁',
    holder: '持有人',
    partner: '伙伴关系',
    potential: '潜在客户',
    student: '学员',
    user: '用户',
    remark: '备注',
  },
  'member': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    company: '所在公司',
    knowChannel: '了解渠道',
    liveCity: '居住城市',
    name: '名称',
    position: '职位',
    gender: '性别',
    genders: {
      unknown: '未知',
      male: '男',
      female: '女',
    },
    userId: 'User',
    vaccinationRecordImage: '新冠疫苗接种记录',
    businessExperience: '商业阅历',
  },
  'user': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    screenName: '名称',
    isBlock: '已冻结',
    profile: 'Profile',
    snsAuthorized: 'Sns authorized',
    likePostsCount: '点赞数',
    starPostsCount: '收藏数',
    viewPostsCount: '浏览数',
    sharePostsCount: '分享数',
    inviteesCount: '邀请人数',
    avatar: '头像',
    parentUser: '推荐人',
    student: '学员信息',
    member: '会员信息',
    inviteRelationship: '推荐关系',
  },
  'inviteRelationship': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    phone: '手机号码',
    parentId: '推荐人',
    userId: '用户',
    remark: '备注',
    parent: '推荐人',
    user: '用户',
    children: '被推荐人',
  },
  'activeStorage/blob': {
    id: 'ID',
    createdAt: '创建时间',
    signedId: 'Signed',
    contentType: '类型',
    filename: '文件名',
    byteSize: 'Byte size',
    url: '内容',
    tagList: 'Tag list',
  },
  'actsAsTaggableOn/tag': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
  },
  'page': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    slug: 'Slug',
    title: '标题',
    type: '类型',
    applicationId: '应用ID',
    viewsCount: '浏览数',
    publishedAt: '发布时间',
    wxacode: '小程序码',
    content: '内容',
  },
  'presetPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    viewsCount: '浏览数',
    content: '内容',
  },
  'staticPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    status: '状态',
    viewsCount: '浏览数',
    wxacode: '小程序码',
    content: '内容',
  },
  'customPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    default: '预置页面',
    miniProgramPath: '小程序路径',
    publishedAt: '最后发布时间',
    formalCustomPageId: 'Formal custom page',
    formalCustomPage: 'Formal custom page',
    canRollbackData: 'Can rollback data',
    configs: '自定义页面',
  },
  'hotWord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    position: '优先级',
    applicationId: '应用ID',
    application: '应用管理',
  },
  'commentableCommentDatum': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    commentsCount: '评论数',
    approvedCommentsCount: 'Approved comments count',
    deletedCommentsCount: 'Deleted comments count',
  },
  'post': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    type: 'Type',
    likesCount: '喜欢数',
    viewsCount: '查看数',
    starsCount: '收藏数',
    sharesCount: '分享数',
    commentsCount: '评论数',
    publishedAt: '发布时间',
    author: '作者',
    source: '来源',
    shareDesc: '分享描述',
    isTop: '置顶',
    contentType: '内容类型',
    contentTypes: {
      richtext: '富文本',
      markdown: 'Markdown',
    },
    note: '附言',
    subtitle: '子标题',
    cover: '封面',
    commentableCommentDatum: 'Commentable comment datum',
    content: '富文本内容',
    markdownContent: 'Markdown内容',
    recommendPostIds: '相关推荐',
    recommendPosts: '相关推荐',
  },
  'article': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    type: 'Type',
    likesCount: '喜欢数',
    viewsCount: '查看数',
    starsCount: '收藏数',
    sharesCount: '分享数',
    commentsCount: '评论数',
    publishedAt: '发布时间',
    author: '作者',
    source: '来源',
    shareDesc: '分享描述',
    isTop: '置顶',
    contentType: '内容类型',
    contentTypes: {
      richtext: '富文本',
      markdown: 'Markdown',
    },
    note: '附言',
    subtitle: '子标题',
    cover: '封面',
    commentableCommentDatum: 'Commentable comment datum',
    content: '富文本内容',
    markdownContent: 'Markdown内容',
    recommendPostIds: '相关推荐',
    recommendPosts: '相关推荐',
  },
  'customPostList': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    remark: '备注',
    title: '标题',
    customPostListsPosts: 'Custom post lists posts',
    postIds: '文章',
    posts: '文章',
  },
  'customPostListsPost': {
    id: 'ID',
    postId: 'Post',
    position: '优先级',
  },
  'comment': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    commentableType: '评论对象类型',
    content: '内容',
    approvedCommentsCount: 'Approved comments count',
    commentableId: '评论对象ID',
    commentsCount: '评论数',
    likesCount: '喜欢数',
    state: 'State',
    states: {
      pending: '待审核',
      approved: '审核通过',
      rejected: '审核不通过',
    },
    creatorId: 'Creator',
    creatorType: 'Creator type',
    deletedAt: '隐藏',
    position: '置顶',
    isDeleted: '隐藏',
    isTop: '置顶',
    parentId: '一级评论ID',
    rootId: 'Root',
    adminRead: '管理员已读',
    creator: '评论者',
    parent: '一级评论',
    commentable: '评论对象',
    commentableCommentDatum: 'Commentable comment datum',
  },
  'normalComment': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    commentableType: '评论对象类型',
    content: '内容',
    approvedCommentsCount: 'Approved comments count',
    commentableId: '评论对象ID',
    commentsCount: '评论数',
    likesCount: '喜欢数',
    state: 'State',
    states: {
      pending: '待审核',
      approved: '审核通过',
      rejected: '审核不通过',
    },
    creatorId: 'Creator',
    creatorType: 'Creator type',
    deletedAt: '隐藏',
    position: '置顶',
    isDeleted: '隐藏',
    isTop: '置顶',
    parentId: '一级评论ID',
    rootId: 'Root',
    adminRead: '管理员已读',
    parent: '一级评论',
    commentable: '评论对象',
    creator: '评论者',
    commentableCommentDatum: 'Commentable comment datum',
  },
  'specialColumn': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    type: 'Type',
    likesCount: '喜欢数',
    viewsCount: '查看数',
    starsCount: '收藏数',
    sharesCount: '分享数',
    commentsCount: '评论数',
    publishedAt: '发布时间',
    author: '作者',
    source: '来源',
    shareDesc: '分享描述',
    isTop: '置顶',
    contentType: '内容类型',
    contentTypes: {
      richtext: '富文本',
      markdown: 'Markdown',
    },
    note: '附言',
    subtitle: '子标题',
    cover: '封面',
    commentableCommentDatum: 'Commentable comment datum',
    content: '富文本内容',
    markdownContent: 'Markdown内容',
    articles: '文章',
    specialColumnArticleRelations: '文章',
    recommendPostIds: '相关推荐',
    recommendPosts: '相关推荐',
  },
  'specialColumnArticleRelation': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    position: '优先级',
    articleId: '文章',
    article: '文章',
  },
  'seekTruthWeekly': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    type: 'Type',
    likesCount: '喜欢数',
    viewsCount: '查看数',
    starsCount: '收藏数',
    sharesCount: '分享数',
    commentsCount: '评论数',
    publishedAt: '发布时间',
    author: '作者',
    source: '来源',
    shareDesc: '分享描述',
    isTop: '置顶',
    contentType: '内容类型',
    contentTypes: {
      richtext: '富文本',
      markdown: 'Markdown',
    },
    cover: '封面',
    content: '富文本内容',
    markdownContent: 'Markdown内容',
    recommendPostIds: '相关推荐',
    recommendPosts: '相关推荐',
  },
  'seekTruthVideo': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    type: 'Type',
    likesCount: '喜欢数',
    viewsCount: '查看数',
    starsCount: '收藏数',
    sharesCount: '分享数',
    commentsCount: '评论数',
    publishedAt: '发布时间',
    author: '作者',
    source: '来源',
    shareDesc: '分享描述',
    isTop: '置顶',
    contentType: '内容类型',
    contentTypes: {
      richtext: '富文本',
      markdown: 'Markdown',
    },
    note: '附言',
    subtitle: '子标题',
    cover: '封面',
    commentableCommentDatum: 'Commentable comment datum',
    video: '视频',
  },
  'bookClub': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    type: 'Type',
    likesCount: '喜欢数',
    viewsCount: '查看数',
    starsCount: '收藏数',
    sharesCount: '分享数',
    commentsCount: '评论数',
    publishedAt: '发布时间',
    author: '作者',
    source: '来源',
    shareDesc: '分享描述',
    isTop: '置顶',
    contentType: '内容类型',
    contentTypes: {
      richtext: '富文本',
      markdown: 'Markdown',
    },
    number: '期次',
    lecturer: '主讲人',
    startAt: '开始时间',
    endAt: '结束时间',
    address: '上课地点',
    note: '附言',
    cover: '封面',
    content: '富文本内容',
    markdownContent: 'Markdown内容',
    images: '图片',
    relatedBookLists: '相关书单',
    relatedBookListIds: '相关书单',
  },
  'bookList': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    type: 'Type',
    likesCount: '喜欢数',
    viewsCount: '查看数',
    starsCount: '收藏数',
    sharesCount: '分享数',
    commentsCount: '评论数',
    publishedAt: '发布时间',
    author: '作者',
    source: '来源',
    shareDesc: '分享描述',
    isTop: '置顶',
    contentType: '内容类型',
    contentTypes: {
      richtext: '富文本',
      markdown: 'Markdown',
    },
    cover: '封面',
    content: '富文本内容',
    markdownContent: 'Markdown内容',
    recommendPostIds: '相关推荐',
    recommendPosts: '相关推荐',
  },
  'podcast': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    type: 'Type',
    likesCount: '喜欢数',
    viewsCount: '查看数',
    starsCount: '收藏数',
    sharesCount: '分享数',
    commentsCount: '评论数',
    publishedAt: '发布时间',
    author: '作者',
    source: '来源',
    shareDesc: '分享描述',
    isTop: '置顶',
    contentType: '内容类型',
    contentTypes: {
      richtext: '富文本',
      markdown: 'Markdown',
    },
    cover: '封面',
    content: '富文本内容',
    markdownContent: 'Markdown内容',
    audio: '音频',
    recommendPostIds: '相关推荐',
    recommendPosts: '相关推荐',
  },
  'experienceComment': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    commentableType: '心得对象类型',
    content: '内容',
    approvedCommentsCount: 'Approved comments count',
    commentableId: '心得对象ID',
    commentsCount: '评论数',
    likesCount: '喜欢数',
    state: 'State',
    states: {
      pending: '待审核',
      approved: '审核通过',
      rejected: '审核不通过',
    },
    creatorId: 'Creator',
    creatorType: 'Creator type',
    deletedAt: '隐藏',
    position: '置顶',
    isDeleted: '隐藏',
    isTop: '置顶',
    parentId: '一级评论ID',
    rootId: 'Root',
    adminRead: '管理员已读',
    commentable: '心得对象',
    creator: '评论者',
    commentableCommentDatum: 'Commentable comment datum',
  },
  'reason': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    kind: '类型',
    kinds: {
      refund: 'Refund',
    },
    isActive: '用户可见',
  },
  'applyRecord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    targetType: 'Target type',
    targetId: '目标',
    userId: 'User',
    state: '状态',
    states: {
      applied: '已报名',
      paid: '已支付',
      refund_audit: '退款待审核',
      refunding: '退款中',
      refunded: '已退款',
    },
    refundReason: '退款原因',
    refundReasonDetail: '退款原因补充说明',
    priceTypeName: '价格类型名称',
    priceTypeAmount: '价格类型金额',
    target: '目标',
    user: '用户',
  },
  'priceType': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    amount: '金额',
    priceTypeTemplateId: 'Price type template',
  },
  'priceTypeTemplate': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    priceTypes: '价格类型',
  },
  'youthCamp': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    type: 'Type',
    likesCount: '喜欢数',
    viewsCount: '查看数',
    starsCount: '收藏数',
    sharesCount: '分享数',
    commentsCount: '评论数',
    publishedAt: '发布时间',
    author: '作者',
    source: '来源',
    shareDesc: '分享描述',
    isTop: '置顶',
    contentType: '内容类型',
    contentTypes: {
      richtext: '富文本',
      markdown: 'Markdown',
    },
    number: '期次',
    startAt: '开始时间',
    endAt: '结束时间',
    lecturer: '主讲人',
    address: '地址',
    applicantsCount: '报名人数',
    priceTypeTemplateId: '价格模板',
    cover: '封面',
    priceTypeTemplate: '价格模板',
    note: '附言',
    content: '富文本内容',
    markdownContent: 'Markdown内容',
    images: '图片',
  },
  'invoiceApplyRecord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    bankAccount: '银行账号',
    bankName: '银行名称',
    companyAddress: '公司地址',
    taxNumber: '税号',
    telephone: '公司电话',
    title: '抬头',
    invoiceType: '发票类型',
    invoiceTypes: {
      vat_general_invoice: '增值税普通发票',
      vat_special_invoice: '增值税专用发票',
      general_invoice: '普通发票',
    },
    state: '状态',
    states: {
      pending: '待处理',
      processing: '处理中',
      processed: '已处理',
    },
    titleType: '抬头类型',
    titleTypes: {
      individual: '个人',
      company: '公司',
    },
    userId: 'User',
    user: '用户',
    applyRecord: '报名记录',
    remark: '备注',
  },
  'youthCampExperienceComment': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    commentableType: '评论对象类型',
    content: '内容',
    approvedCommentsCount: 'Approved comments count',
    commentableId: '评论对象ID',
    commentsCount: '评论数',
    likesCount: '喜欢数',
    state: 'State',
    states: {
      pending: '待审核',
      approved: '审核通过',
      rejected: '审核不通过',
    },
    creatorId: 'Creator',
    creatorType: 'Creator type',
    deletedAt: '隐藏',
    position: '置顶',
    isDeleted: '隐藏',
    isTop: '置顶',
    parentId: '一级评论ID',
    rootId: 'Root',
    adminRead: '管理员已读',
    creator: '评论者',
    commentableCommentDatum: 'Commentable comment datum',
  },
  'operationRecord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    content: '内容',
    contentEn: 'Content en',
    adminUser: '管理员',
    previousObject: 'Previous object',
    currentObject: 'Current object',
  },
  'setting': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
  },
}
